import OwnerDetails from './OwnerDetails';

export default OwnerDetails;
